module.exports = __webpack_public_path__ + "static/media/a2.fd72891b.jpg";